import Alpine from 'alpinejs';
import { CartService } from '../service/CartService';
import { AllProducts } from '../registry/ProductRegistry';
import { AlpineDataToast } from '../alpine-data/Toast';

(window as typeof window & { Alpine: typeof Alpine }).Alpine = Alpine;

document.addEventListener('alpine:init', () => {
  const cartService = new CartService();

  Alpine.data('productPage', () => ({
    quantity: 1,

    async addToCart(id: string) {
      const prod = AllProducts.find(p => p.id === id)
      if (prod) {
        cartService.addToCart(prod, this.quantity);

        return prod
      }
    }
  }));

  AlpineDataToast();

});

Alpine.start();
